<template lang="pug">
div(
    :data-product-id="yotpoId"
    :data-name="yotpoName"
    :data-url="dataURL"
    class="yotpo yotpo-main-widget"
)
</template>
<script>
import mixin from './mixin'

export default {
    mixins: [mixin],
    props: {
        yotpoId: {
            type: String,
            required: true,
        },
        yotpoName: {
            type: String,
            required: true,
        },
    },
    computed: {
        dataURL() {
            return 'https://' + this.$sitewideData.domain + '/p/' + this.$route.params.productLine
        },
    },
}
</script>

<style lang="stylus">
#app
    .yotpo.yotpo-main-widget
        width 100%
    @screen lg
        .yotpo.yotpo-main-widget
            width 75%
    .write-question-review-buttons-container .write-question-review-button
        height auto
</style>
